import { plain, secured } from '@/plugins/axios';

const resource = '/users/admin';

export default {
    login: payload => plain.post(`${resource}/login/`, payload),
    logout: () => secured.post(`${resource}/logout/`),
    me: () => secured.get(`${resource}/me/`),
    all: params => secured.get(`${resource}/users/`, { params }),
    create: payload => secured.post(`${resource}/users/`, payload),
    get: id => secured.get(`${resource}/users/${id}/`),
    edit: payload => secured.put(`${resource}/users/${payload.id}`, payload),

    roles: () => secured.get(`${resource}/roles/`),
};
